import { memo } from 'react';

import type { LbPart } from '../../types';

const Card = ({ part: { data } }: { part: LbPart }) => (
  <div>
    <div>Card</div>
    <div className='lb-composer-wrap'>
      <div>Type: {data.Type}</div>
      <div>Data: {data.Id}</div>
      <div>Component: {data.Component}</div>
    </div>
  </div>
);

export default memo(Card);
